var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.5,
    height: 17.502,
    viewBox: "0 0 18.5 17.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m3.623 17.5 1-6.374L0 6.625l6.375-.875L9.25 0l2.875 5.75 6.374.875-4.625 4.5L15 17.5l-5.749-3-5.625 3zm5.627-4.375.5.374 3.5 1.751-.626-3.876-.125-.624.5-.5 2.75-2.625-3.874-.5L11.25 7 11 6.375 9.25 2.876 7.5 6.25l-.251.624L6.625 7l-3.875.5 2.75 2.75.375.375-.125.626-.624 3.875 3.5-1.749.624-.25z",
    style: {
      fill: "#505866"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnStar);
export default __webpack_public_path__ + "static/media/icn_star.9b1d2e33bbe5c5ecf5f788d222309cf7.svg";
export { ForwardRef as ReactComponent };